// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { DocumentFragment } from '../../../documents/graphql/DocumentFragment.generated';
import { gql } from '@apollo/client';
import { DocumentFragmentDoc } from '../../../documents/graphql/DocumentFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDocumentRepresentationListDocumentsQueryVariables = Types.Exact<{
  documentsLike: Types.DocumentWhereInput;
}>;


export type GetDocumentRepresentationListDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: (
        { __typename?: 'Document' }
        & DocumentFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetDocumentRepresentationListDocuments: 'GetDocumentRepresentationListDocuments' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetDocumentRepresentationListDocumentsDocument = gql`
    query GetDocumentRepresentationListDocuments($documentsLike: DocumentWhereInput!) {
  documents(where: $documentsLike, orderBy: {field: created_at, direction: DESC}) {
    edges {
      node {
        ...Document
      }
    }
  }
}
    ${DocumentFragmentDoc}`;

/**
 * __useGetDocumentRepresentationListDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentRepresentationListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentRepresentationListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentRepresentationListDocumentsQuery({
 *   variables: {
 *      documentsLike: // value for 'documentsLike'
 *   },
 * });
 */
export function useGetDocumentRepresentationListDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentRepresentationListDocumentsQuery, GetDocumentRepresentationListDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentRepresentationListDocumentsQuery, GetDocumentRepresentationListDocumentsQueryVariables>(GetDocumentRepresentationListDocumentsDocument, withFetchPolicyContext(options));
      }
export function useGetDocumentRepresentationListDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentRepresentationListDocumentsQuery, GetDocumentRepresentationListDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentRepresentationListDocumentsQuery, GetDocumentRepresentationListDocumentsQueryVariables>(GetDocumentRepresentationListDocumentsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetDocumentRepresentationListDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentRepresentationListDocumentsQuery, GetDocumentRepresentationListDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentRepresentationListDocumentsQuery, GetDocumentRepresentationListDocumentsQueryVariables>(GetDocumentRepresentationListDocumentsDocument, withFetchPolicyContext(options));
        }
export type GetDocumentRepresentationListDocumentsQueryHookResult = ReturnType<typeof useGetDocumentRepresentationListDocumentsQuery>;
export type GetDocumentRepresentationListDocumentsLazyQueryHookResult = ReturnType<typeof useGetDocumentRepresentationListDocumentsLazyQuery>;
export type GetDocumentRepresentationListDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentRepresentationListDocumentsSuspenseQuery>;
export type GetDocumentRepresentationListDocumentsQueryResult = Apollo.QueryResult<GetDocumentRepresentationListDocumentsQuery, GetDocumentRepresentationListDocumentsQueryVariables>;